<template>
  <div class="d-inline-flex align-items-center mt-3 w-100">
    <b-row class="w-100 align-items-center">
      <b-col md="3" class="branch-label">
        Branch
      </b-col>
      <b-col md="9">
        <b-dropdown
          id="cc-branch-dropdown"
          :text="displaySelectedBranch"
          :toggle-class="['bg-transparent shadow-none text-left position-relative  pr-4', { 'no-selected': !selectedBranch }]"
          menu-class="p-0 mt-2"
          class="w-100"
          :disabled="isDropdownDisabled"
          :title="displaySelectedBranch">
          <template v-if="loading.branches">
            <b-dropdown-item>Loading...</b-dropdown-item>
          </template>
          <template v-else-if="!loading.branches && branchesByBrand.length === 0">
            <div class="p-2 text-center text-muted">
              No available branches.
            </div>
          </template>
          <template v-else>
            <b-dropdown-item
              v-for="(branch, index) in branchesByBrand"
              :key="`branch-${branch.name}-${index}`"
              class="py-2 px-3 d-flex align-items-center justify-content-between"
              @click="setSelectedBranch(branch.uuid)"
              :title="branch.name">
              {{ branch.name }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      selectedBrand: "conversationalCommerce/selectedBrand",
      selectedBranch: "conversationalCommerce/selectedBranch",
      branches: "conversationalCommerce/branches",
      branchesByBrand: "conversationalCommerce/branchesByBrand",
      loading: "conversationalCommerce/loading",
      selectedOrder: "conversationalCommerce/selectedOrder",
      cartItems: "conversationalCommerce/cartItems",
      isMultiplePurchaseAllowed: "conversationalCommerce/isMultiplePurchaseAllowed"
    }),
    isDropdownDisabled: {
      get() {
        return !this.selectedBrand;
      },
      set(status) {
        return status;
      }
    },
    displaySelectedBranch: {
      get() {
        return this.selectedBranch
          ? this.branches.find(branch => branch.uuid === this.selectedBranch).name
          : "Select"
      },
      set(branch) {
        return branch;
      }
    },
    cartBranches: {
      get() {
        if (this.cartItems && this.cartItems.cart_count > 0) return this.cartItems.list.map(list => list.branch_uuid);
        else return [];
      },
      set(branchUuids) {
        return branchUuids;
      }
    }
  },
  created() {
    this.$store.dispatch("conversationalCommerce/getBranches");
  },
  methods: {
    setSelectedBranch(value) {
      if (
        this.selectedOrder
        && !this.isMultiplePurchaseAllowed
        && (this.cartItems && this.cartItems.cart_count > 0)
        && !this.cartBranches.includes(value)
      ) this.$root.$emit('bv::show::modal', 'changing-branch-prompt');
      else this.$store.commit("conversationalCommerce/setSelectedBranch", value);
    }
  },
  watch: {
    selectedBrand() {
      this.setSelectedBranch(null);
      this.$store.commit("conversationalCommerce/setBranchesByBrand");
    },
    selectedBranch(branch) {
      if (branch) this.$store.dispatch("conversationalCommerce/getBranchProducts");
      else this.$store.commit("conversationalCommerce/setProducts", { products: [], isInfinite: false });
    }
  }
}
</script>

<style lang="scss" scoped>
.branch-label {
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  font-size: 14px;
  color: #2F3941;
}
</style>

<style lang="scss">
#cc-branch-dropdown {
  .dropdown-toggle {
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    color: #49545C;
    min-width: 150px;
    border-color: #E9EBED;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.no-selected {
      color: #87929D;
    }
    &::after {
      position: absolute;
      border: 0;
      width: 9px;
      height: 6px;
      background: url('~@/assets/images/caret-down.svg') no-repeat center;
      bottom: 15px;
      right: 15px;
    }
  }
  .dropdown-menu {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    background: #fff;
    .dropdown-item {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
